export default __webpack_public_path__ + "static/media/Title&Escrow_white.eeff59f4.svg";